import { render, staticRenderFns } from "./OliveOilDetail.vue?vue&type=template&id=776b14e6&scoped=true"
import script from "./OliveOilDetail.vue?vue&type=script&lang=js"
export * from "./OliveOilDetail.vue?vue&type=script&lang=js"
import style0 from "./OliveOilDetail.vue?vue&type=style&index=0&id=776b14e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b14e6",
  null
  
)

export default component.exports